/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WachtwoordRouteImport } from './routes/wachtwoord'
import { Route as UitnodigingRouteImport } from './routes/uitnodiging'
import { Route as PasswordRouteImport } from './routes/password'
import { Route as NewPhoneRouteImport } from './routes/new-phone'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InvitationRouteImport } from './routes/invitation'
import { Route as ForgotRouteImport } from './routes/forgot'
import { Route as ChooseCompanyRouteImport } from './routes/choose-company'
import { Route as PortalRouteImport } from './routes/_portal'
import { Route as PortalIndexRouteImport } from './routes/_portal/index'
import { Route as PortalWarehouseOrdersRouteImport } from './routes/_portal/warehouse-orders'
import { Route as PortalWarehouseOrderRouteImport } from './routes/_portal/warehouse-order'
import { Route as PortalStockRouteImport } from './routes/_portal/stock'
import { Route as PortalShipmentsRouteImport } from './routes/_portal/shipments'
import { Route as PortalOrderRouteImport } from './routes/_portal/order'
import { Route as PortalShipmentsNumberRouteImport } from './routes/_portal/shipments_.$number'
import { Route as PortalAccountRecoveryCodesRouteImport } from './routes/_portal/account/recovery-codes'
import { Route as PortalAccountPhoneRouteImport } from './routes/_portal/account/phone'
import { Route as PortalAccountPasswordRouteImport } from './routes/_portal/account/password'

const WachtwoordRoute = WachtwoordRouteImport.update({
  id: '/wachtwoord',
  path: '/wachtwoord',
  getParentRoute: () => rootRouteImport,
} as any)
const UitnodigingRoute = UitnodigingRouteImport.update({
  id: '/uitnodiging',
  path: '/uitnodiging',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordRoute = PasswordRouteImport.update({
  id: '/password',
  path: '/password',
  getParentRoute: () => rootRouteImport,
} as any)
const NewPhoneRoute = NewPhoneRouteImport.update({
  id: '/new-phone',
  path: '/new-phone',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationRoute = InvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const ChooseCompanyRoute = ChooseCompanyRouteImport.update({
  id: '/choose-company',
  path: '/choose-company',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/_portal',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalWarehouseOrdersRoute = PortalWarehouseOrdersRouteImport.update({
  id: '/warehouse-orders',
  path: '/warehouse-orders',
  getParentRoute: () => PortalRoute,
} as any)
const PortalWarehouseOrderRoute = PortalWarehouseOrderRouteImport.update({
  id: '/warehouse-order',
  path: '/warehouse-order',
  getParentRoute: () => PortalRoute,
} as any)
const PortalStockRoute = PortalStockRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => PortalRoute,
} as any)
const PortalShipmentsRoute = PortalShipmentsRouteImport.update({
  id: '/shipments',
  path: '/shipments',
  getParentRoute: () => PortalRoute,
} as any)
const PortalOrderRoute = PortalOrderRouteImport.update({
  id: '/order',
  path: '/order',
  getParentRoute: () => PortalRoute,
} as any)
const PortalShipmentsNumberRoute = PortalShipmentsNumberRouteImport.update({
  id: '/shipments_/$number',
  path: '/shipments/$number',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAccountRecoveryCodesRoute =
  PortalAccountRecoveryCodesRouteImport.update({
    id: '/account/recovery-codes',
    path: '/account/recovery-codes',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalAccountPhoneRoute = PortalAccountPhoneRouteImport.update({
  id: '/account/phone',
  path: '/account/phone',
  getParentRoute: () => PortalRoute,
} as any)
const PortalAccountPasswordRoute = PortalAccountPasswordRouteImport.update({
  id: '/account/password',
  path: '/account/password',
  getParentRoute: () => PortalRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof PortalIndexRoute
  '/choose-company': typeof ChooseCompanyRoute
  '/forgot': typeof ForgotRoute
  '/invitation': typeof InvitationRoute
  '/login': typeof LoginRoute
  '/new-phone': typeof NewPhoneRoute
  '/password': typeof PasswordRoute
  '/uitnodiging': typeof UitnodigingRoute
  '/wachtwoord': typeof WachtwoordRoute
  '/order': typeof PortalOrderRoute
  '/shipments': typeof PortalShipmentsRoute
  '/stock': typeof PortalStockRoute
  '/warehouse-order': typeof PortalWarehouseOrderRoute
  '/warehouse-orders': typeof PortalWarehouseOrdersRoute
  '/account/password': typeof PortalAccountPasswordRoute
  '/account/phone': typeof PortalAccountPhoneRoute
  '/account/recovery-codes': typeof PortalAccountRecoveryCodesRoute
  '/shipments/$number': typeof PortalShipmentsNumberRoute
}
export interface FileRoutesByTo {
  '/choose-company': typeof ChooseCompanyRoute
  '/forgot': typeof ForgotRoute
  '/invitation': typeof InvitationRoute
  '/login': typeof LoginRoute
  '/new-phone': typeof NewPhoneRoute
  '/password': typeof PasswordRoute
  '/uitnodiging': typeof UitnodigingRoute
  '/wachtwoord': typeof WachtwoordRoute
  '/order': typeof PortalOrderRoute
  '/shipments': typeof PortalShipmentsRoute
  '/stock': typeof PortalStockRoute
  '/warehouse-order': typeof PortalWarehouseOrderRoute
  '/warehouse-orders': typeof PortalWarehouseOrdersRoute
  '/': typeof PortalIndexRoute
  '/account/password': typeof PortalAccountPasswordRoute
  '/account/phone': typeof PortalAccountPhoneRoute
  '/account/recovery-codes': typeof PortalAccountRecoveryCodesRoute
  '/shipments/$number': typeof PortalShipmentsNumberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_portal': typeof PortalRouteWithChildren
  '/choose-company': typeof ChooseCompanyRoute
  '/forgot': typeof ForgotRoute
  '/invitation': typeof InvitationRoute
  '/login': typeof LoginRoute
  '/new-phone': typeof NewPhoneRoute
  '/password': typeof PasswordRoute
  '/uitnodiging': typeof UitnodigingRoute
  '/wachtwoord': typeof WachtwoordRoute
  '/_portal/order': typeof PortalOrderRoute
  '/_portal/shipments': typeof PortalShipmentsRoute
  '/_portal/stock': typeof PortalStockRoute
  '/_portal/warehouse-order': typeof PortalWarehouseOrderRoute
  '/_portal/warehouse-orders': typeof PortalWarehouseOrdersRoute
  '/_portal/': typeof PortalIndexRoute
  '/_portal/account/password': typeof PortalAccountPasswordRoute
  '/_portal/account/phone': typeof PortalAccountPhoneRoute
  '/_portal/account/recovery-codes': typeof PortalAccountRecoveryCodesRoute
  '/_portal/shipments_/$number': typeof PortalShipmentsNumberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/choose-company'
    | '/forgot'
    | '/invitation'
    | '/login'
    | '/new-phone'
    | '/password'
    | '/uitnodiging'
    | '/wachtwoord'
    | '/order'
    | '/shipments'
    | '/stock'
    | '/warehouse-order'
    | '/warehouse-orders'
    | '/account/password'
    | '/account/phone'
    | '/account/recovery-codes'
    | '/shipments/$number'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/choose-company'
    | '/forgot'
    | '/invitation'
    | '/login'
    | '/new-phone'
    | '/password'
    | '/uitnodiging'
    | '/wachtwoord'
    | '/order'
    | '/shipments'
    | '/stock'
    | '/warehouse-order'
    | '/warehouse-orders'
    | '/'
    | '/account/password'
    | '/account/phone'
    | '/account/recovery-codes'
    | '/shipments/$number'
  id:
    | '__root__'
    | '/_portal'
    | '/choose-company'
    | '/forgot'
    | '/invitation'
    | '/login'
    | '/new-phone'
    | '/password'
    | '/uitnodiging'
    | '/wachtwoord'
    | '/_portal/order'
    | '/_portal/shipments'
    | '/_portal/stock'
    | '/_portal/warehouse-order'
    | '/_portal/warehouse-orders'
    | '/_portal/'
    | '/_portal/account/password'
    | '/_portal/account/phone'
    | '/_portal/account/recovery-codes'
    | '/_portal/shipments_/$number'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PortalRoute: typeof PortalRouteWithChildren
  ChooseCompanyRoute: typeof ChooseCompanyRoute
  ForgotRoute: typeof ForgotRoute
  InvitationRoute: typeof InvitationRoute
  LoginRoute: typeof LoginRoute
  NewPhoneRoute: typeof NewPhoneRoute
  PasswordRoute: typeof PasswordRoute
  UitnodigingRoute: typeof UitnodigingRoute
  WachtwoordRoute: typeof WachtwoordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wachtwoord': {
      id: '/wachtwoord'
      path: '/wachtwoord'
      fullPath: '/wachtwoord'
      preLoaderRoute: typeof WachtwoordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uitnodiging': {
      id: '/uitnodiging'
      path: '/uitnodiging'
      fullPath: '/uitnodiging'
      preLoaderRoute: typeof UitnodigingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password': {
      id: '/password'
      path: '/password'
      fullPath: '/password'
      preLoaderRoute: typeof PasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-phone': {
      id: '/new-phone'
      path: '/new-phone'
      fullPath: '/new-phone'
      preLoaderRoute: typeof NewPhoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitation': {
      id: '/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof InvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot': {
      id: '/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/choose-company': {
      id: '/choose-company'
      path: '/choose-company'
      fullPath: '/choose-company'
      preLoaderRoute: typeof ChooseCompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_portal': {
      id: '/_portal'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_portal/': {
      id: '/_portal/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/warehouse-orders': {
      id: '/_portal/warehouse-orders'
      path: '/warehouse-orders'
      fullPath: '/warehouse-orders'
      preLoaderRoute: typeof PortalWarehouseOrdersRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/warehouse-order': {
      id: '/_portal/warehouse-order'
      path: '/warehouse-order'
      fullPath: '/warehouse-order'
      preLoaderRoute: typeof PortalWarehouseOrderRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/stock': {
      id: '/_portal/stock'
      path: '/stock'
      fullPath: '/stock'
      preLoaderRoute: typeof PortalStockRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/shipments': {
      id: '/_portal/shipments'
      path: '/shipments'
      fullPath: '/shipments'
      preLoaderRoute: typeof PortalShipmentsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/order': {
      id: '/_portal/order'
      path: '/order'
      fullPath: '/order'
      preLoaderRoute: typeof PortalOrderRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/shipments_/$number': {
      id: '/_portal/shipments_/$number'
      path: '/shipments/$number'
      fullPath: '/shipments/$number'
      preLoaderRoute: typeof PortalShipmentsNumberRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/account/recovery-codes': {
      id: '/_portal/account/recovery-codes'
      path: '/account/recovery-codes'
      fullPath: '/account/recovery-codes'
      preLoaderRoute: typeof PortalAccountRecoveryCodesRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/account/phone': {
      id: '/_portal/account/phone'
      path: '/account/phone'
      fullPath: '/account/phone'
      preLoaderRoute: typeof PortalAccountPhoneRouteImport
      parentRoute: typeof PortalRoute
    }
    '/_portal/account/password': {
      id: '/_portal/account/password'
      path: '/account/password'
      fullPath: '/account/password'
      preLoaderRoute: typeof PortalAccountPasswordRouteImport
      parentRoute: typeof PortalRoute
    }
  }
}

interface PortalRouteChildren {
  PortalOrderRoute: typeof PortalOrderRoute
  PortalShipmentsRoute: typeof PortalShipmentsRoute
  PortalStockRoute: typeof PortalStockRoute
  PortalWarehouseOrderRoute: typeof PortalWarehouseOrderRoute
  PortalWarehouseOrdersRoute: typeof PortalWarehouseOrdersRoute
  PortalIndexRoute: typeof PortalIndexRoute
  PortalAccountPasswordRoute: typeof PortalAccountPasswordRoute
  PortalAccountPhoneRoute: typeof PortalAccountPhoneRoute
  PortalAccountRecoveryCodesRoute: typeof PortalAccountRecoveryCodesRoute
  PortalShipmentsNumberRoute: typeof PortalShipmentsNumberRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalOrderRoute: PortalOrderRoute,
  PortalShipmentsRoute: PortalShipmentsRoute,
  PortalStockRoute: PortalStockRoute,
  PortalWarehouseOrderRoute: PortalWarehouseOrderRoute,
  PortalWarehouseOrdersRoute: PortalWarehouseOrdersRoute,
  PortalIndexRoute: PortalIndexRoute,
  PortalAccountPasswordRoute: PortalAccountPasswordRoute,
  PortalAccountPhoneRoute: PortalAccountPhoneRoute,
  PortalAccountRecoveryCodesRoute: PortalAccountRecoveryCodesRoute,
  PortalShipmentsNumberRoute: PortalShipmentsNumberRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PortalRoute: PortalRouteWithChildren,
  ChooseCompanyRoute: ChooseCompanyRoute,
  ForgotRoute: ForgotRoute,
  InvitationRoute: InvitationRoute,
  LoginRoute: LoginRoute,
  NewPhoneRoute: NewPhoneRoute,
  PasswordRoute: PasswordRoute,
  UitnodigingRoute: UitnodigingRoute,
  WachtwoordRoute: WachtwoordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
